
export const PHASE_ANSWERING = 0
export const PHASE_WAITING_NEXT = 1
export const PHASE_GAMEOVER = 99